import { updateProfile } from "./update-profile";
import { updateGateways } from "./update-gateways";
import { createResultOfPay } from "./create-result-of-pay";
import { createError } from "./create-validation-error";
import { createToken } from "./create-token";
import { changePayData } from "./change-pay-data";
import { createCurrentGateway } from "./create-current-gateway";
import { saveLocation } from "./save-location";
import { createFocus } from "./create-focus";
import { virtualSettings } from "./virtual-settings";
import { changePayInfo } from "./change-pay-info";
import { initTheme } from "./init-theme";
import { createMethod } from "./create-method";
import { changeBaseAmount } from "./change-amount";
import { changeAmountFirstStep } from "./change-amount-first-step";
import { changePanoramicStep } from "@pano-project/features/panoramic-billing-page/state/change-panoramic-step";
import { panoramicPmSelection } from "@pano-project/features/panoramic-billing-page/state/panoramic-pm-selection";
import { pendingTransactions } from "./pending-transactions";
import { withdrawalRequests } from "./withdrawal-requests";
import { createGatewayInfo } from "./create-gateway-info";
import { limitSubmit } from "./limit-submit";
import { createAdrToken } from "./create-adr-token";
import { limitError } from "./limit-error";
import { createCardToObSettings } from "./create-card-to-ob-settings.ts";
import { updateProcessingGatewaysList } from "./update-processing-gateways";
import { createSessionId } from "./create-session-id";
import { setEnableSessionEvents } from "./set-enable-session-events";
import { bonusModalState } from "./bonus-modal-state";
import { selectedBonus } from "./selected-bonus-state";
import { wasPartialApproval } from "./was-partial-approval";
import { portalWrappers } from "./portal-wrappers";
import { maintenanceModalState } from "./maintenance-modal-state";
import { forceValidationDisable } from "./force-validation-disable";
import { isManualAmountChange } from "./manual-amount-change";

const reducer = (state, action) => {
  return {
    token: createToken(state, action),
    adrToken: createAdrToken(state, action),
    initTheme: initTheme(state, action),
    location: saveLocation(state, action),
    gatewaysList: updateGateways(state, action),
    profileInfo: updateProfile(state, action),
    resultOfPay: createResultOfPay(state, action),
    processingGatewaysList: updateProcessingGatewaysList(state, action),
    errors: createError(state, action),
    payData: changePayData(state, action),
    payInfo: changePayInfo(state, action),
    currentGateway: createCurrentGateway(state, action),
    gatewayInfo: createGatewayInfo(state, action),
    focus: createFocus(state, action),
    method: createMethod(state, action),
    limitSubmit: limitSubmit(state, action),
    changedAmount: changeBaseAmount(state, action),
    amountFirstStep: changeAmountFirstStep(state, action),
    panoramicBillingPageStep: changePanoramicStep(state, action),
    panoramicPmSelection: panoramicPmSelection(state, action),
    bonusModalState: bonusModalState(state, action),
    selectedBonus: selectedBonus(state, action),
    virtualSettings: virtualSettings(state, action),
    pendingTransactions: pendingTransactions(state, action),
    withdrawalRequests: withdrawalRequests(state, action),
    limitError: limitError(state, action),
    cardToObSettings: createCardToObSettings(state, action),
    sessionId: createSessionId(state, action),
    enableSessionEvents: setEnableSessionEvents(state, action),
    wasPartialApproval: wasPartialApproval(state, action),
    portalWrappers: portalWrappers(state, action),
    maintenanceModalState: maintenanceModalState(state, action),
    forceValidationDisable: forceValidationDisable(state, action),
    isManualAmountChange: isManualAmountChange(state, action),
  };
};
export default reducer;
